import { FC } from 'react';

import { WebpImage } from 'components/Shared/SharedComponents';

import styles from './PlainItemsWithDescription.module.scss';

import type { PlainItemIconInterface as IconInterface } from '../config/declarations';
import { getLocalImage } from '../lib';

export const Icon: FC<IconInterface> = ({ image, images }) => {
  const localImage = getLocalImage(image, images);

  if (!localImage?.image?.url) {
    return null;
  }

  const { url } = localImage.image;

  const finalImage = localImage.image.fileName?.includes('svg')
    ? 'external'
    : localImage.image;

  return (
    <WebpImage
      src={url}
      image={finalImage}
      className={styles.liImage}
      {...(localImage.size && {
        height: localImage.size.height,
        width: localImage.size.width,
        style: localImage.size,
      })}
    />
  );
};
